import { LogoPropsType } from './logoTypes';

export default function KotlinLogo({ monochrome = false, className }: LogoPropsType) {
  return (
    <svg viewBox="0 0 49 50" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M48.9918 49.4664H0.507812V0.982422H48.9918L24.7498 25.2244L48.9918 49.4664Z"
        fill={monochrome ? 'currentColor' : 'url(#paint0_linear_12819_13634)'}
      />
      <defs>
        <linearGradient
          id="paint0_linear_12819_13634"
          x1="48.9921"
          y1="0.981749"
          x2="0.507411"
          y2="49.4664"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.003" stopColor="#E44857" />
          <stop offset="0.469" stopColor="#C711E1" />
          <stop offset="1" stopColor="#7F52FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
